import { IInsights } from '../../../common/models/Insights'
import { GET_INSIGHTS_STATISTICS } from '../../../constants/api'
import errorHandler from '../errorHandler'

export default (token: string, termNumber: number) =>
  fetch(GET_INSIGHTS_STATISTICS(termNumber), {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then(errorHandler)
    .then(
      async (response: Response): Promise<IInsights> => {
        const result = await response.json()
        return result
      }
    )
